import React, { useCallback, useEffect, useState, useRef } from "react";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles, createStyles } from "@material-ui/styles";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import SettingsIcon from "@material-ui/icons/Settings";
import CategoryIcon from "@material-ui/icons/Category";
import BusinessIcon from "@material-ui/icons/Business";
import HistoryIcon from "@material-ui/icons/History";
import PersonIcon from "@material-ui/icons/Person";
import StoreIcon from "@mui/icons-material/Store";
import { push } from "connected-react-router";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import TextInput from "../UIkit/TextInput";
import { useDispatch, useSelector } from "react-redux";
import { signOutUser } from "../../reducks/users/operations";
import { getUserRole } from "../../reducks/users/selectors";
import { fetchCategories } from "../../reducks/categories/operations";
import { getCategories } from "../../reducks/categories/selectors";
import { updateSearchKeywordsAction } from "../../reducks/searchKeywords/actions";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";
import CurrencyYenIcon from "@mui/icons-material/CurrencyYen";
import { PERMISSIONS } from "../../constants/permissions";
import NotificationsIcon from "@mui/icons-material/Notifications";
const useStyles = makeStyles((theme) =>
  createStyles({
    drawer: {
      [theme.breakpoints.up("sm")]: {
        width: 256,
        flexShrink: 0,
      },
    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
      width: 256,
    },
    searchField: {
      alignItems: "center",
      display: "flex",
      marginLeft: 32,
    },
  })
);

const ClosableDrawer = (props) => {
  const classes = useStyles();
  const { container } = props;
  const dispatch = useDispatch();
  //const selector = useSelector(state  => state);
  const userRole = useSelector(getUserRole);
  const isAdministrator =
    userRole === PERMISSIONS.ADMINISTRATOR ||
    userRole === PERMISSIONS.HUMAN_RESOURCE_USER;
  const isViewer = userRole === PERMISSIONS.VIEWER;
  const [searchKeyword, setSearchKeyword] = useState("");
  const categories = useSelector(getCategories);
  const searchKeywordRef = useRef(""); // useRefを使用して参照を作成
  let currentSearchKeyword = "";

  const selectMenu = (event, path) => {
    currentSearchKeyword = searchKeywordRef.current;
    dispatch(push(path));
    dispatch(updateSearchKeywordsAction(currentSearchKeyword));
    setSearchKeyword("");
    currentSearchKeyword = "";
    searchKeywordRef.current = "";
    props.onClose(event);
  };
  const [filters, setFilters] = useState([
    { func: selectMenu, label: "すべて", id: "all", value: "/" },
    // {func: selectMenu, label:"メンズ", id: "male", value: "/?gender=male"},
    // {func: selectMenu, label:"レディース", id: "female", value: "/?gender=female"},
  ]);
  const menus = [
    {
      func: selectMenu,
      label: "商品登録",
      icon: <AddCircleIcon />,
      id: "productRegister",
      value: "/product/menu",
    },
    {
      func: selectMenu,
      label: "カテゴリー登録",
      icon: <CategoryIcon />,
      id: "categoriesRegister",
      value: "/categories/edit",
    },
    {
      func: selectMenu,
      label: "販売店登録",
      icon: <StoreIcon />,
      id: "shopsRegister",
      value: "/shops/edit",
    },
    {
      func: selectMenu,
      label: "メーカー登録",
      icon: <SettingsIcon />,
      id: "makerRegister",
      value: "/makers/edit",
    },
    {
      func: selectMenu,
      label: "発注部署登録",
      icon: <BusinessIcon />,
      id: "orderingDapatmentRegister",
      value: "/ordering-department/menu",
    },
    {
      func: selectMenu,
      label: "ユーザー登録",
      icon: <ManageAccountsIcon />,
      id: "usersRegister",
      value: "/users/edit",
    },
    // {
    //   func: selectMenu,
    //   label: "エクスポート",
    //   icon: <SystemUpdateAltIcon />,
    //   id: "exportRegister",
    //   value: "/export/csv",
    // },
    {
      func: selectMenu,
      label: "発注処理",
      icon: <CurrencyYenIcon />,
      id: "orderProcessing",
      value: "/order/processing",
    },
    {
      func: selectMenu,
      label: "注文履歴",
      icon: <HistoryIcon />,
      id: "history",
      value: "/order/history",
    },
    {
      func: selectMenu,
      label: "お知らせ",
      icon: <NotificationsIcon />,
      id: "notice",
      value: "/notice/list",
    },

    {
      func: selectMenu,
      label: "プロフィール",
      icon: <PersonIcon />,
      id: "profile",
      value: "/user/mypage",
    },
  ];

  const inputSearchKeyword = useCallback(
    (event) => {
      event.stopPropagation();
      setSearchKeyword(event.target.value);
      //currentSearchKeyword = event.target.value;
      searchKeywordRef.current = event.target.value;
    },
    [setSearchKeyword]
  );

  const searchButtonClickHandler = (e) => {
    console.log(searchKeywordRef.current);
    dispatch(updateSearchKeywordsAction(searchKeyword));
    setSearchKeyword("");
    currentSearchKeyword = "";
    searchKeywordRef.current = "";
    props.onClose(e, false);
  };

  const createFiltersFromCategories = () => {
    const filtersFromCategories = [];
    categories.forEach((category) => {
      filtersFromCategories.push({
        func: selectMenu,
        label: category.name,
        id: category.cid,
        value: `/?category=${category.cid}`,
      });
    });
    return filtersFromCategories;
  };
  const onCloseHandler = (e) => {
    setSearchKeyword("");
    props.onClose(e, false);
  };
  /*
    useEffect(() => {
        dispatch(fetchCategories());
    }, []);
    */
  useEffect(() => {
    const initialFilters = [
      { func: selectMenu, label: "すべて", id: "all", value: "/" },
      // {func: selectMenu, label:"メンズ", id: "male", value: "/?gender=male"},
      // {func: selectMenu, label:"レディース", id: "female", value: "/?gender=female"},
    ];
    const filtersFromCategories = createFiltersFromCategories();
    setFilters([...initialFilters, ...filtersFromCategories]);
  }, [categories]);

  return (
    <nav className={classes.drawer} aria-label="mailbox folders">
      <Drawer
        container={container}
        variant="temporary"
        anchor={"right"}
        open={props.open}
        onClose={(e) => onCloseHandler(e)}
        classes={{
          paper: classes.drawerPaper,
        }}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
      >
        <div
          onClose={(e) => onCloseHandler(e)}
          onKeyDown={(e) => onCloseHandler(e)}
        >
          <div className={classes.searchField}>
            <TextInput
              fullWidth={false}
              label={"商品名・説明で検索"}
              multiline={false}
              onChange={inputSearchKeyword}
              onKeyDown={inputSearchKeyword}
              required={false}
              minRows={1}
              value={searchKeyword}
              type={"text"}
            />
            <IconButton onClick={(e) => searchButtonClickHandler(e)}>
              <SearchIcon />
            </IconButton>
          </div>
          <Divider />
          <List>
            {/* {menus.map(
              (menu) =>
                !isViewer &&
                ((isAdministrator && menu.id.includes("Register")) ||
                  !menu.id.includes("Register")) && (
                  <ListItem
                    button
                    key={menu.id}
                    onClick={(e) => menu.func(e, menu.value)}
                  >
                    <ListItemIcon>{menu.icon}</ListItemIcon>
                    <ListItemText primary={menu.label} />
                  </ListItem>
                )
            )} */}
            {isAdministrator &&
              menus.map((menu) => (
                <ListItem
                  button
                  key={menu.id}
                  onClick={(e) => menu.func(e, menu.value)}
                >
                  <ListItemIcon>{menu.icon}</ListItemIcon>
                  <ListItemText primary={menu.label} />
                </ListItem>
              ))}
            {userRole === PERMISSIONS.ORDER_USER &&
              menus
                .filter((menu) => !menu.id.includes("Register"))
                .map((menu) => (
                  <ListItem
                    button
                    key={menu.id}
                    onClick={(e) => menu.func(e, menu.value)}
                  >
                    <ListItemIcon>{menu.icon}</ListItemIcon>
                    <ListItemText primary={menu.label} />
                  </ListItem>
                ))}
            {userRole === PERMISSIONS.NORMAL_USER &&
              menus
                .filter(
                  (menu) =>
                    !menu.id.includes("Register") &&
                    menu.id !== "orderProcessing"
                )
                .map((menu) => (
                  <ListItem
                    button
                    key={menu.id}
                    onClick={(e) => menu.func(e, menu.value)}
                  >
                    <ListItemIcon>{menu.icon}</ListItemIcon>
                    <ListItemText primary={menu.label} />
                  </ListItem>
                ))}
            <ListItem
              button
              key="logout"
              onClick={(e) => {
                dispatch(signOutUser());
                props.onClose(e, false);
              }}
            >
              <ListItemIcon>
                <ExitToAppIcon />
              </ListItemIcon>
              <ListItemText primary={"サインアウト"} />
            </ListItem>
          </List>
          <Divider />
          <List>
            {filters.map((filter) => (
              <ListItem
                button
                key={filter.id}
                onClick={(e) => filter.func(e, filter.value)}
              >
                <ListItemText primary={filter.label} />
              </ListItem>
            ))}
          </List>
        </div>
      </Drawer>
    </nav>
  );
};

export default ClosableDrawer;
